/* eslint-disable no-unused-vars */
import $ from 'jquery';

// Remove form errors summary
if ($("form[data-hide_errors_summary='1']").length) {
    $('.drupal-messages').remove();
}
